<template>
    <div class="">        
        <section>                              
            <div>   
                <div class="d-flex justify-content-between p-3">                    
                    <section class="d-flex">
                        <span class="p-2 font-weight-bold" v-if="orders">
                                <span class="text-muted">Found</span> {{orders.length}}
                        </span>
                        <div class="dropdown">
                            <a class="btn btn-light dropdown-toggle" 
                                href="#" role="button" id="dropdownMenuLink" 
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Filters
                            </a>                        
                            <div class="dropdown-menu border-0 shadow p-3" aria-labelledby="dropdownMenuLink" style="min-width: 25vw">
                                    <div class="form-group d-flex justify-content-between">
                                        <label class="p-2">Search</label>
                                        <input type="text" class="col-8 form-control" v-model="search"> 
                                    </div> 
                                    <div class="form-group d-flex justify-content-between">
                                        <label >Since</label>
                                        <select class="col-8 form-control" v-model="date_range">
                                            <option value=1>today</option>
                                            <option value=2>yesterday</option>
                                            <option value=7>last 7 days</option>
                                            <option value=14>last 14 days</option>
                                            <option value=30>last 30 days</option>
                                            <option value=90>last 3 months</option>
                                        </select>
                                    </div>														
                                    <div class="form-group d-flex justify-content-between">
                                        <label class="p-2">From</label>
                                        <input type="date" name="bday" max="3000-12-31" 
                                        min="1000-01-01" class="col-8 form-control" v-model="from_date"> 
                                    </div> 
                                    <div class="form-group d-flex justify-content-between">
                                        <label class="p-2">To</label>
                                        <input type="date" name="bday" max="3000-12-31" 
                                        min="1000-01-01" class="col-8 form-control" v-model="to_date"> 
                                    </div> 
                                    <div class="ml-2 d-flex justify-content-end">
                                        <button class="btn btn-outline-success"  @click="getOrders()">Get Orders</button>
                                    </div>	
                            </div>
                        </div>
                        <div class="ml-2">
                            <button class="btn btn-outline-success"
                                @click="$exportTable('ordersTable','orders.csv')">
                                Export to CSV
                            </button>	
                        </div>	
                    </section>                                  																							
                </div>             
                <table class="table table-borderless table-responsive-sm">
                    <thead >
                        <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Customer</th>
                        <th scope="col">Placed on</th>
                        <th scope="col">Date of delivery</th>
                        <th scope="col">Total Items</th>
                        <th scope="col">State</th>
                        <th scope="col">Actions</th>
                        </tr>
                    </thead>                    
                    <tbody>
                        <tr v-for = "(order,index) in orders" :key="index">                            
                            <td>{{order.id}}</td>
                            <td>{{order.customer_id.name}}</td>
                            <td>{{order.placed_on | fromNow}}</td>
                            <td>{{order.date_of_delivery | fromNow}}</td>
                            <td>{{order.items.length}}</td>
                            <td>{{order.state}}</td>                            
                            <td>
                                <span class="hidden mt-0" style="position:absolute;right: 0px;">
                                    <span style="height: 25px; visibility: hidden">hidden</span>
                                    <span class="d-flex">
                                        <button class="btn btn-sm btn-success" 
                                            @click="openReceipt(order)">
                                            view receipt
                                        </button>
                                        <button class="ml-2 btn btn-sm btn-danger">remove</button>
                                    </span>										
                                </span>
                            </td>                            
                        </tr>                   
                    </tbody>                    
                </table>
                <div class="p-3 d-flex justify-content-center"
                    v-if="orders && ! orders.length">
                    <span class="p-2">No records to show since</span>
                    <div class="form-group d-flex justify-content-between">								
                        <select class="form-control" v-model="date_range">
                            <option value=1>today</option>
                            <option value=2>yesterday</option>
                            <option value=7>last 7 days</option>
                            <option value=14>last 14 days</option>
                            <option value=30>last 30 days</option>
                            <option value=90>last 3 months</option>
                        </select>
                    </div>	
                </div>
                <div class="p-3 d-flex justify-content-center"
                    v-if="! orders">
                    <div class="spinner-border p-3 m-5" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <!-- view order modal -->
                  <!-- modals -->
                <!-- Button trigger modal -->
                <button type="button" id="order-modal" class="d-none btn" data-toggle="modal" data-target="#orderModal">
                    Launch receipt modal
                </button>
                
                <!-- Modal -->
                <div class="modal fade" id="orderModal" tabindex="-1" role="dialog" aria-labelledby="orderModal" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div class="modal-content" v-if="modal_data">
                        <div class="modal-header border-0">
                        <h5 class="modal-title font-weight-bold" >
                            Order No. {{modal_data.id}} 
                            <span class="badge badge-danger">{{modal_data.state}}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        </div>
                        <div class="modal-body">								
                            <h4 class="text-muted"></h4>                       
                                <table class="table table-borderless table-responsive-sm">													
                                    <thead>
                                        <tr>												
                                        <th scope="col">Product</th>
                                        <th scope="col">variant</th>
                                        <th scope="col">Quantity</th>                                        
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for = "(item,index) in modal_data.items" :key="index">												
                                            <td>{{item.product_name}}</td>
                                            <td>{{item.variant_id}}</td>
                                            <td>{{item.quantity}}</td>                                            
                                        </tr>												
                                    </tbody>
                                </table>                           
                        </div>
                        <div class="modal-footer">
                                <span class="d-flex justify-content-between">
                                    <label class="font-weight-bold">Placed on:</label>
                                    <i class="ml-2">
                                        {{modal_data.placed_on | dateformat}}
                                        ({{modal_data.placed_on | fromNow}})
                                    </i>
                                </span>	
                                <span class="d-flex justify-content-between">
                                    <label class="font-weight-bold">Delivery:</label>
                                    <i class="ml-2">
                                        {{modal_data.date_of_delivery | dateformat}}
                                        ({{modal_data.date_of_delivery | fromNow}})
                                    </i>
                                </span>	
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    export default {
        name: 'productOrders',
        props: {
            product_id: null
        },
        data(){
            return{
                search:null,
                orders:null,
                date_range:1,
                modal_data:null,
                from_date: null,
                to_date: null,
            }
        },
        mounted(){
            this.from_date = this.$moment().subtract(this.date_range, 'days').format('YYYY-MM-DD')
            this.to_date = this.$moment().format('YYYY-MM-DD')
            this.getOrders()            
        },
        watch:{
            date_range: function(){
                if (this.date_range){
                    this.from_date = this.$moment().subtract(this.date_range, 'days').format('YYYY-MM-DD')
                    this.to_date = this.$moment().format('YYYY-MM-DD')
                    this.getOrders()
                }
            },
            search:function(){			
                this.$searchTable('ordersTable',this.search)			
            }
        },
        methods:{		
            //get_products
            getOrders: function(){            
                this.orders = null
                this.$http({
                    method:'get',				
                    url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/sale-orders/`,
                    headers:{
                        Authorization: JSON.parse(localStorage.getItem('auth_token'))
                    },
                    params:{
                        date0: this.from_date,
                        date1: this.to_date
                    },
                }).then((response)=>{
                    this.orders = response.data
                    this.orders = this.orders.filter((order)=>{
                    //if there are products in the sale
                    if(order.items.length){
                        //loop trough products in the sale
                        for(var i in order.items){
                            //if there is a sale with this product in the products list
                            if (order.items[i].product_id === this.product_id){
                                return order
                            }
                        }
                    }
                })	
                }).catch((err)=>{
                    this.$emit('alert',err)
                })
            },
            openReceipt: function(order){
                //create modal data
                this.modal_data = order
                console.log(this.modal_data)
                //open modal
                var button = document.getElementById('order-modal')
                button.click()
            }
        },      
    }
</script>
          